module.exports = __webpack_public_path__ + "static/media/beep_medium.7e840077.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/beep_medium.mp3
// module id = 23
// module chunks = 0